<template>
    <div>
        <div class="row">
            <div class="column small-9">
                <PageTitle title="Logs" :total="total" :loading="loading" />
            </div>
            <!-- <div class="column small-3 text-right">
                <b-button type="is-dark" tag="router-link" to="/panel/organisaties/nieuw">Nieuwe organisatie</b-button>
            </div> -->
        </div>

        <div class="row">
            <div class="column">
                <LogRecords
                    ref="LogsRecord"
                    searchParamName="LogsOverview"
                    :showAdminTab="true"
                    :showFilters="true"
                    :pagination="true"
                    @passTotal="passTotal"
                    @passLoading="passLoading"
                />
            </div>
        </div>
    </div>
</template>

<script>
import LogRecords from './LogsRecord.vue'

export default {
    components: {
        LogRecords
    },

    data () {
        return {
            total: null,
            loading: false
        }
    },

    mounted () {
        this.$refs['LogsRecord'].load()
    },

    methods: {
        passTotal(total){
            this.total = total
        },
        passLoading(loading){
            this.loading = loading
        }
    }
}
</script>